// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1m8Yn","delete":"styles_delete__1E7hl","update":"styles_update__2kmJN","add":"styles_add__uiNPF"};